import { Form, Space } from 'antd';

import { Error403Unauthorized } from '@app/components';
import { RecordsPriorityIntegration } from '@app/pages/Notifications/components/RecordsPriorityIntegration';
import { useRecordNotifications } from '@app/pages/Notifications/hooks';

import { NotificationsButtons } from '@pages/Notifications/components/NotificationsButtons.main';

import {
  NotificationVisitReminder,
  Notification2hReminder,
  FeedbackRequest,
  NotificationCreateMessage,
} from '@pages/Notifications/components';

import type { FC } from 'react';

import '@pages/Notifications/styles/RecordNotifications.desktop.scss';

export type TFormValues = {
  priorityIntegration: string;
  createMessage: {
    enabled: boolean;
    message: string;
  };
};

export const RecordNotifications: FC = () => {
  const {
    form,
    isSaveDisabled,
    handleSave,
    createRecordBoxRef,
    visitReminderBoxRef,
    visitDayReminderBoxRef,
    notifications,
    setNotifications,
    deleteNotification,
    hasUserPermission,
    createRecordReminder,
    generalReminder,
    visitDayReminder,
    feedbackReminder,
    defaultIntegrations,
    setDefaultIntegrations,
    pageServerData,
    sendToAll,
    setSendToAll,
    sendByLastActiveIntegration,
    setSendByLastActiveIntegration,
    IsEditReminders,
  } = useRecordNotifications();

  if (!hasUserPermission) {
    return <Error403Unauthorized />;
  }

  return (
    <div className="bc-notifications-page">
      <Form form={form} className="bc-notifications-page__form">
        <Space
          className="bc-notifications-page__container"
          direction="vertical"
          size={36}
        >
          <RecordsPriorityIntegration
            defaultIntegrations={defaultIntegrations}
            setDefaultIntegrations={setDefaultIntegrations}
            data={pageServerData}
            sendToAll={sendToAll}
            setSendToAll={setSendToAll}
            sendByLastActiveIntegration={sendByLastActiveIntegration}
            setSendByLastActiveIntegration={setSendByLastActiveIntegration}
            disabled={!IsEditReminders}
          />
          <NotificationCreateMessage
            form={form}
            createRecordBoxRef={createRecordBoxRef}
            reminder={createRecordReminder}
            disabled={!IsEditReminders}
          />
          <NotificationVisitReminder
            form={form}
            visitReminderBoxRef={visitReminderBoxRef}
            notifications={notifications}
            setNotifications={setNotifications}
            deleteNotification={deleteNotification}
            reminder={generalReminder}
            disabled={!IsEditReminders}
          />
          <Notification2hReminder
            form={form}
            boxRef={visitDayReminderBoxRef}
            reminder={visitDayReminder}
            disabled={!IsEditReminders}
          />
          <FeedbackRequest
            form={form}
            reminder={feedbackReminder}
            disabled={!IsEditReminders}
          />
          <NotificationsButtons
            onSave={handleSave}
            isSaveDisabled={isSaveDisabled}
            disabled={!IsEditReminders}
          />
        </Space>
      </Form>
    </div>
  );
};
